import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {wantedPost} from 'services/wantedPost';

const useWantedPost = ({resetForm}: IUseWantedPost) => {
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: wantedBody) => {
      return wantedPost(payload);
    },
    onSuccess: (_, variables) => {
      const appType =
        variables.profile_type === 'farmer' ? 'farm' : 'wholesaler';
      navigate('/' + appType + '/home');
      resetForm();
    },
  });
  return {isLoading, mutate};
};
export default useWantedPost;
